const mealTypes = ["Breakfast", "Lunch", "Dinner", "Snacks"];

const ALL_DAYS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

const DAY_TO_DATE_FNS_INDEX = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const mealOrderMap = {
  Breakfast: "BREAKFAST",
  Lunch: "LUNCH",
  Dinner: "DINNER",
  Snacks: "SNACK",
};

function getDayOrder(weekStartDay = "MONDAY") {
  const startIndex = ALL_DAYS.indexOf(weekStartDay);
  return [
    ...ALL_DAYS.slice(startIndex),
    ...ALL_DAYS.slice(0, startIndex),
  ];
}

export { mealTypes, mealOrderMap, getDayOrder, DAY_TO_DATE_FNS_INDEX };
